import { render, staticRenderFns } from "./LiveQAModalComponent.vue?vue&type=template&id=677e8fb2&scoped=true&"
import script from "./LiveQAModalComponent.vue?vue&type=script&lang=js&"
export * from "./LiveQAModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./LiveQAModalComponent.vue?vue&type=style&index=0&id=677e8fb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e8fb2",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BImg, BRow, BButton, BLink, BCol, BAvatar, BContainer, BModal} from 'bootstrap-vue'
    installComponents(component, {BImg, BRow, BButton, BLink, BCol, BAvatar, BContainer, BModal})
    

export default component.exports